import {useMemo} from 'react';

import {getUsersInfo} from 'src/modules/users-info/services';
import {useAppSelector} from 'src/store';

export const useUserNameMapper = () => {
    const usersInfo = useAppSelector(getUsersInfo);
    const usersEmails = Object.keys(usersInfo);
    const emailToName: Record<string, string> = useMemo(() => {
        if (!usersEmails.length) {
            return {};
        }
        return usersEmails.reduce((memo, email) => {
            if (usersInfo?.[email]?.firstName || usersInfo?.[email]?.lastName) {
                return {
                    ...memo, [email]: `${usersInfo?.[email]?.firstName || ''} ${usersInfo?.[email]?.lastName || ''}`,
                };
            }
            if (usersInfo?.[email]?.email) {
                return {
                    ...memo, [email]: `${usersInfo?.[email]?.email}`,
                };
            }
            return {...memo, email};
        }, {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usersInfo]);

    const nameToEmail: Record<string, string> = useMemo(() => {
        if (!usersEmails.length) {
            return {};
        }
        return {...Object.fromEntries(Object.entries(emailToName).map(([key, value]) => [value, key]))};
    }, [emailToName, usersEmails.length]);

    return {emailToName, nameToEmail};
};
